export default __webpack_public_path__ + "static/media/logo.f9e4dcea.png";